export const redirectToExternalUrl = url =>
  window.Cypress
    ? // eslint-disable-next-line no-console
      console.info(`Redirected to ${url}`)
    : window.location.replace(url);
